import { RouteRecordRaw } from 'vue-router';
import { VerificationDocumentPage, verificationItemGuard } from '@/pages/verification';

export const routeName = 'VerificacaoDocumento';

export const route: RouteRecordRaw = {
  // O segmento `registro` separa as duas naturezas. Sem ele, `/verificacao/61` seria ambiguo: 61
  // pode ser uma revisao de documento E uma matriz, porque as duas tabelas tem sequencia propria.
  // O segmento e opcional de proposito: uma URL sem ele vale como natureza documento, que e o que
  // ela sempre significou, entao link antigo continua abrindo o que abria.
  path: 'verificacao/:nature(registro)?/:id',
  name: routeName,
  component: VerificationDocumentPage,
  beforeEnter: verificationItemGuard,
  meta: {
    requiresAuth: true,
    remountOnParamsChange: true,
    breadcrumb: 'Etapa de Verificação e Vigência',
    dynamicBreadcrumb: true,
    permissions: [{ action: 'manageVerification', subject: 'Homologation' }],
  },
};
